import { useMemo } from 'react';
import styled, { css, useTheme } from 'foundations-theming/utils';
import { useDragLayer } from 'react-dnd';
import { Image } from 'foundations-components/transitional/components/Image';
import DragHandle from 'FormsCommonComponents/editor/draggable/DragHandle';
import { fieldTypesWithIcon, IconMapping, NewFieldIconMapping } from 'ui-forms-components/constants/propertyIcons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconWrapper = styled.div.withConfig({
  displayName: "CustomFieldDragLayer__IconWrapper"
})(["width:66px;height:66px;display:flex;justify-content:center;align-items:center;"]);
const DragLayerContainer = styled.div.attrs(({
  clientOffset
}) => ({
  style: clientOffset ? {
    transform: `translate(${clientOffset.x}px, ${clientOffset.y}px)`
  } : {
    display: 'none'
  }
}))(({
  theme
}) => {
  return css(["background-color:", ";border-radius:", ";text-align:center;padding:", ";position:fixed;pointer-events:none;z-index:100;left:0;top:0;width:", ";height:", ";opacity:0.7;display:flex;flex-direction:column;align-items:center;justify-content:space-between;"], theme.color['text-interactive-default'], theme.borderRadius['100'], theme.space['0'], theme.space['1500'], theme.space['1500']);
});
const isUnsupportedBrowser = () => {
  const userAgent = window.navigator.userAgent;
  return userAgent.indexOf('Edge/') !== -1 || userAgent.indexOf('Trident/') !== -1 || userAgent.indexOf('MSIE ') !== -1;
};
const CustomFieldDragLayer = () => {
  const trellisTheme = useTheme();
  const isUnsupported = isUnsupportedBrowser();
  const {
    isDragging,
    clientOffset,
    item
  } = useDragLayer(monitor => ({
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset(),
    item: monitor.getItem() || {}
  }));
  const icon = useMemo(() => {
    if (!item || !item.isCreateNewField || !item.fieldType) {
      return null;
    }

    // @ts-expect-error its fine
    const isIcon = fieldTypesWithIcon[item.fieldType];
    // @ts-expect-error its fine
    const fieldIconImage = NewFieldIconMapping[item.fieldType];
    // @ts-expect-error its fine
    const FieldIconSource = IconMapping[item.fieldType];
    return isIcon ? /*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(FieldIconSource, {
        size: '700'
      })
    }) : /*#__PURE__*/_jsx(Image, {
      src: fieldIconImage,
      width: 66,
      height: 42
    });
  }, [item]);
  if (!isDragging || isUnsupported || !item.isCreateNewField) {
    return null;
  }
  return /*#__PURE__*/_jsxs(DragLayerContainer, {
    clientOffset: clientOffset,
    children: [/*#__PURE__*/_jsx(DragHandle, {
      color: trellisTheme.color['fill-surface-default']
    }), icon]
  });
};
export default CustomFieldDragLayer;